import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import ArgonDashboard from "./argon-dashboard";
import './assets/css/style.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* Font-Awesome Free Icons */
import {
    faUserSecret,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faCheck,
    faPenToSquare,
    faEye,
    faStopwatch,
    faEnvelope,
    faComment,
} from '@fortawesome/free-solid-svg-icons'

/* Font-Awesome Brand Icons */
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(
    faUserSecret,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faCheck,
    faPenToSquare,
    faEye,
    faStopwatch,
    faEnvelope,
    faComment,
    faWhatsapp
)

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const appInstance = createApp(App);
appInstance.component('font-awesome-icon', FontAwesomeIcon);
appInstance.use(store);
appInstance.use(router);
appInstance.use(VueSweetalert2);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
